// removed by extract-text-webpack-plugin
module.exports = {"category":"category","category-color":"category-color","category-icon":"category-icon","category-name":"category-name","unknown":"unknown","disabled":"disabled","filled":"filled"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/category/category.style.sass
// module id = 2CaH
// module chunks = 0